<template>
  <div class="otaUpgrade">
    <div class="content">
      <div class="title">雷鸟AR眼镜 固件升级</div>

      <div class="steps">
        <div class="one step">
          <div class="icon" :class="step === 1 ? 'currentBg' : step > 1 ? 'computedBg' : ''">
            <span v-show="step === 1">1</span>
            <img v-show="step > 1" src="../../assets/images/computed.png" alt="" />
          </div>
          <div class="text">连接眼镜</div>
        </div>
        <div class="line"></div>
        <div class="two step">
          <div class="icon" :class="step === 2 ? 'currentBg' : step === 3 ? 'computedBg' : ''">
            <span v-show="step < 3">2</span>
            <img v-show="step === 3" src="../../assets/images/computed.png" alt="" />
          </div>
          <div class="text">升级固件</div>
        </div>
      </div>

      <div class="tipsContent">
        <div class="text">
          本页面仅支持雷鸟GT、GT MAX、Air 4 Pro、Air 4、Air 3s Pro、Air 3s、Air 3、Air 2s、Air 2、Air Plus、Air 1s 眼镜固件升级，电脑可通过版本号大于89的chrome浏览器进行操作。
        </div>
        <div class="text">
          请确保升级过程中
          <div class="t_blod">仅有一台雷鸟眼镜与电脑连接</div>
          ，连接后电脑可能会有闪烁，属于正常现象。
        </div>
        <div class="text" v-if="isGTDevice">
          温馨提示：升级完成后大约会黑屏15秒再亮屏，黑屏过程中请勿拔出眼镜。
        </div>
      </div>

      <div class="oneComponent" v-show="step === 1">
        <div class="oneBox">
          <div class="left">
            <div class="title">连接指引</div>
            <div class="items">
              <div class="item">
                <div class="num">1</div>
                <div class="text">
                  请将眼镜接入电脑的 USB-C 口，并点击「开始连接」。
                </div>
              </div>
              <div class="item">
                <div class="num">2</div>
                <div class="text">
                  连接时若弹出弹窗，请在弹窗列表内选择你的眼镜设备，并点击「连接」按钮。
                </div>
              </div>

              <div class="leftTips" @click="handleToShow">
                Windows 设备无法识别雷鸟Air plus、Air 1s？
              </div>
            </div>
          </div>
          <img class="right" src="../../assets/images/guide.png" alt="" />
        </div>

        <div class="btn" @click="handleToConnect" v-loading="requestLoading">
          开始连接
        </div>
        <div class="error" v-if="!online">网络异常，请检查网络后重试</div>
      </div>
      <div class="twoComponent" v-show="step === 2">
        <div v-loading="loading">
          <div class="twoBox">
            <!-- <img class="left" :src="deviceImg" alt="" /> -->
            <div class="left" v-if="deviceImg" v-html="deviceImg"></div>
            <img class="left" v-if="!loading && !deviceImg" src="../../assets/images/noGlasses.png" alt="" />

            <div class="right">
              <div class="deviceName">{{ deviceName }}</div>
              <div class="deviceVersion" :class="deviceVersionClass">
                {{ deviceVersionText }}
              </div>
              <div class="upgradeVersion success" v-show="!isDFU && upgradeVersion && !showProgress">
                {{
                  upgradeVersion > currentVersion
                    ? `新固件版本 ${upgradeVersion} 可升级`
                    : "已是最新固件版本"
                }}
                <div class="viewDetail" v-show="upgradeVersion > currentVersion" @click="showDetail = true">
                  详情
                </div>
              </div>
            </div>
          </div>

          <div v-show="firmwareUrl && !showProgress && upgradeVersion > currentVersion
            ">
            <div class="btn" @click="handleToUpgrade">
              {{ initStatus ? "修复固件" : "升级固件" }}
            </div>
            <div class="error" v-if="!online">网络异常，请检查网络后重试</div>
            <div class="tips">
              升级时若弹出弹窗，请在弹窗内选择你的眼镜并点击「连接」
            </div>
          </div>

          <div class="upgrading" v-show="showProgress && (upgrading === 1 || (upgrading === 3 && step !== 3))">
            <div class="success upgradeVersion">
              正在{{ initStatus ? "修复" : "升级" }}固件
            </div>
            <el-progress :percentage="percentage" color="rgba(46, 186, 84, 1)" :stroke-width="strokeWidth"
              :show-text="false" define-back-color="rgba(229, 230, 235, 1)"></el-progress>
            <div class="tips">请不要离开当前页面或拔出眼镜</div>
          </div>
        </div>
      </div>
      <div class="threeComponent" v-show="step === 3">
        <div class="threeBox" v-if="upgradStatus">
          <img src="../../assets/images/success.png" alt="" />
          <div class="text">固件{{ initStatus ? "修复" : "升级" }}成功</div>
          <div class="tips">
            {{ deviceName }} 已升级至最新固件版本 {{ upgradeVersion }}
          </div>
        </div>
        <div class="threeBox" v-else>
          <img src="../../assets/images/error.png" alt="" />

          <div class="text">固件{{ initStatus ? "修复" : "升级" }}失败</div>

          <el-tooltip placement="top" v-if="uploadErrTip">
            <div slot="content" class="tips tipsContentErr">
              {{ uploadErrTip }}
            </div>
            <div class="tips">{{ upgradText }}</div>
          </el-tooltip>

          <div slot="content" class="tips" v-else>
            {{ upgradText }}
          </div>

          <!--  -->
          <div class="tips">
            如重复遇到问题，请尝试拔掉眼镜、刷新页面后再重新进行操作
          </div>
        </div>
      </div>

      <div v-if="step === 3 && !upgradStatus">
        <div class="btn" @click="handleToReUpgrade">重新升级</div>
        <div class="error" v-if="!online">网络异常，请检查网络后重试</div>
      </div>
    </div>

    <TipsModel :show="show" :onCancel="handleToClose"></TipsModel>
    <OTAModel :show="showDetail" :version="upgradeVersion" :instrodution="instrodution" :onCancel="handleToCloseDetail">
    </OTAModel>
  </div>
</template>

<style scoped lang="less">
.tipsContentErr {
  width: 400px;
  font-size: 12px;
}

.otaUpgrade {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 0;

  .t_blod {
    display: inline-block;
    font-weight: 600;
    color: #333;
  }

  .content {
    width: 1200px;
  }

  .title {
    font-size: 42px;
    font-weight: 600;
    line-height: 60px;
    text-align: center;
  }

  .steps {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 52px;

    .step {
      display: flex;
      align-items: center;

      .icon {
        background-color: rgba(242, 243, 245, 1);
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        border-radius: 50%;
        color: #505050;
        font-weight: bold;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .currentBg {
        background-color: #2d4fff;
        color: #fff;
      }

      .computedBg {
        background-color: rgba(232, 243, 255, 1);
      }

      .text {
        font-size: 20px;
        margin-left: 8px;
        font-weight: 500;
        line-height: 24px;
      }
    }

    .line {
      width: 140px;
      height: 1px;
      background-color: rgb(229, 230, 235);
      margin: 0 16px;
    }
  }

  .error {
    text-align: center;
    color: rgba(229, 63, 58, 1);
    font-size: 20px;
    margin-top: 10px;
    line-height: 34px;
  }

  .tipsContent {
    margin-bottom: 32px;
    width: 100%;
    background-color: rgba(242, 244, 247, 1);
    border-radius: 12px;
    padding: 30px 40px;
    box-sizing: border-box;
    margin-top: 42px;
    border: 1px solid rgba(242, 243, 249, 1);

    .text {
      font-size: 18px;
      line-height: 38px;
      color: rgba(80, 80, 80, 1);

      &::before {
        content: "•";
        color: rgba(80, 80, 80, 1);
        // margin-right: 8px;
      }
    }
  }

  .oneComponent {
    .oneBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fcfcfd;
      padding: 50px 40px 40px;
      box-sizing: border-box;
      border: 1px solid rgba(242, 243, 249, 1);
      border-radius: 12px;

      .title {
        text-align: left;
        font-size: 28px;
        line-height: 48px;
        margin-bottom: 16px;
      }

      .items {
        .item {
          display: flex;
          align-items: flex-start;
          font-size: 18px;
          line-height: 31px;
          width: 527px;
          margin-bottom: 6px;

          .text {
            flex: 1;
            margin-top: 2px;
          }

          .num {
            width: 18px;
            height: 18px;
            color: #fff;
            background-color: #505050;
            margin-right: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            font-size: 12px;
            position: relative;
            top: 8px;
            left: 0px;
          }
        }
      }

      .leftTips {
        display: inline-block;
        color: #2d4fff;
        font-size: 18px;
        line-height: 32px;
        border-bottom: 1px solid #2d4fff;
        margin-top: 10px;
        cursor: pointer;
      }

      .right {
        width: 547px;
        height: 296px;
      }
    }
  }

  .twoComponent {
    .twoBox {
      background-color: #fcfcfd;
      padding: 50px 40px 40px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      border: 1px solid rgba(242, 243, 249, 1);
      border-radius: 12px;

      .left {
        width: 547px;
        height: 296px;
        border-radius: 12px;
        margin-right: 30px;

        p {
          margin: 0px;
          padding: 0px;
          width: 100%;
          height: 100%;
        }

        img {
          width: 547px;
          height: 296px;
        }
      }

      .right {
        >div {
          margin-bottom: 16px;
        }

        .deviceName {
          font-size: 28px;
          line-height: 36px;
          font-family: SourceHanSansSC-Bold;
        }

        .deviceVersion {
          font-size: 18px;
          line-height: 31px;
        }

        .upgradeVersion {
          font-size: 18px;
          line-height: 32px;

          .viewDetail {
            display: inline-block;
            cursor: pointer;
            margin-left: 16px;
            color: #2d4fff;
          }
        }
      }
    }

    .tips {
      font-size: 18px;
      color: #606060;
      text-align: center;
      line-height: 32px;
      margin-top: 12px;
      word-wrap: break-word;
    }

    .upgrading {
      width: 800px;
      margin-left: 50%;
      transform: translateX(-50%);
      margin-top: 32px;

      >div {
        margin-bottom: 12px;
        text-align: center;
        font-size: 18px;
      }
    }
  }

  .threeComponent {
    .threeBox {
      background-color: #fcfcfd;
      padding: 50px 40px 40px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border: 1px solid rgba(242, 243, 249, 1);
      border-radius: 12px;

      img {
        width: 120px;
        height: 120px;
        margin-bottom: 28px;
      }

      .text {
        font-size: 28px;
        line-height: 36px;
        font-family: SourceHanSansSC-Bold;
      }

      .tips {
        font-size: 18px;
        color: #505050;
        text-align: center;
        line-height: 32px;
        margin-top: 12px;
      }
    }
  }

  .btn {
    display: inline-block;
    margin-top: 52px;
    min-width: 196px;
    height: 64px;
    border-radius: 160px;
    padding: 16px 58px;
    background-color: #2d4fff;
    color: #fff;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    box-sizing: border-box;
    margin-left: 50%;
    transform: translateX(-50%);
    cursor: pointer;

    &:hover {
      background-color: rgba(97, 122, 255, 1);
    }

    &:active {
      background-color: #243fcc;
    }
  }

  .success {
    color: rgba(46, 186, 84, 1);
  }

  .error {
    color: rgba(229, 63, 58, 1);
  }

  .upgradingText{
    color: #ffaa40;
  }
}
</style>

<script>
import TipsModel from "./components/TipsModel.vue";
import OTAModel from "./components/otaInstrodution.vue";
import {
  getXrOTA,
  getDeviceName,
  getDeviceImg,
  reportData,
  reportOTATracking,
} from "../../serverice/api";
import {
  requestOut,
  requestIn,
  getDeviceParam,
  readInterfaceNamesMapping,
  getDFUDescriptorProperties,
  resetUsbSessionForDfuSwitch,
  recoverRayneoDfuControlForVersionProbe,
} from "../../utils/webusb.js";
import { unzipDfuEntries } from "../../utils/zip-dfu.js";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    TipsModel,
    OTAModel,
  },
  data () {
    return {
      instrodution: "",
      showDetail: false,
      step: 1,
      show: false,
      online: true,
      isDFU: false,
      strokeWidth: 28,
      percentage: 0,
      upgrading: 0, // 0 未升级  1:升级中  2:升级完成-升级失败 3:升级完成 - 升级成功
      currentDevice: null,
      //   selectedDevice: null,
      currentVersion: null,
      upgradeVersion: null,
      firmwareUrl: "",
      loading: false,
      settings: {
        configuration: "",
        interface: "",
        alternate: "",
        name: "",
      },
      glass_version: 0x00,
      cu_version: null,
      isChanged: false,
      upgradText: "",
      upgradStatus: 0, //0 升级失败  1 升级成功
      isDownLoad: false,
      /** manifest 阶段断线后的兜底成功定时器，需在重连/正常成功时 clear */
      manifestSuccessFallbackTimerId: null,
      glassDeviceType: null,
      deviceTypeName: "",
      deviceImg: "",
      deviceName: "",
      connectTimer: null,
      requestLoading: false,
      initStatus: 0, // 0HID 1DFU
      uploadErrTip: "",
      showProgress: "",
    };
  },
  created () {
    this.initData();
    this.handleResize();
    this.updateNetworkStatus();
  },
  mounted () {
    this.resetData();

    this.onConnect();

    navigator.usb.addEventListener("disconnect", this.onUnexpectedDisconnect);
    navigator.usb.addEventListener("connect", this.onConnect);
  },
  beforeDestroy () {   this.clearManifestSuccessFallbackTimer();
    navigator.usb.removeEventListener(
      "disconnect",
      this.onUnexpectedDisconnect
    );
    navigator.usb.removeEventListener("connect", this.onConnect);
  },
  computed: {
    ...mapState("upgrade", ["isFirstConnect", "selectedDevice"]),
    isFirmwareUpgrading () {
      return this.upgrading === 1 && this.showProgress;
    },
    deviceVersionClass () {
      if (this.isFirmwareUpgrading) return "upgradingText";
      if (this.isDFU) return "error";
      return "";
    },
    deviceVersionText () {
      let text = this.initStatus ? '修复' : '升级';
      if (this.isFirmwareUpgrading) return  `固件${text}中，请耐心等待`;
      if (this.isDFU) return "固件已损坏，请及时修复";
      if(this.currentVersion) return `当前固件版本 ${this.currentVersion}`;
      return "";
    },
    // 判断是否显示黑屏时长提示（仅 GT / GT MAX）
    isGTDevice () {
      const result =
        (this.deviceName && this.deviceName.includes('GT')) ||
        (this.glassDeviceType && ['Gemini1p0', 'Gemini2p0'].includes(this.glassDeviceType.deviceType));
      console.log('[isGTDevice] deviceName:', this.deviceName, 'glassDeviceType:', this.glassDeviceType, '=>', result);
      return result;
    },
    canNext () {
      console.log(
        "this.currentVersion",
        this.currentVersion,
        this.firmwareUrl,
        this.deviceName,
        this.deviceImg
      );

      if (
        this.currentVersion &&
        this.firmwareUrl &&
        this.deviceName &&
        this.deviceImg
      ) {
        return true;
      }

      return false;
    },
  },
  watch: {
    canNext (newValue) {
      console.log("this.loading", newValue);
      if (newValue) {
        this.loading = false;
      }
    },
  },
  methods: {
    ...mapMutations("upgrade", ["resetData", "updateData"]),
    recoverRayneoDfuControlForVersionProbe,
    initData () {
      this.isChanged = false;
      this.percentage = 0;
      this.upgrading = 0;
      this.step = 1;
      this.requestLoading = false;
      this.currentVersion = "";
      this.upgradeVersion = "";
      this.firmwareUrl = "";
      this.deviceImg = "";
      this.deviceName = "";
      this.initStatus = 0;
      this.showProgress = false;
      this.clearManifestSuccessFallbackTimer();
    },
    clearManifestSuccessFallbackTimer () {
      if (this.manifestSuccessFallbackTimerId != null) {
        clearTimeout(this.manifestSuccessFallbackTimerId);
        this.manifestSuccessFallbackTimerId = null;
      }
    },
    /** 升级已成功终态：避免 getDeviceVersion / onConnect / handleToReq 等 await 返回后把 step 回写成 2 */
    isFirmwareUpgradeSuccessFinal () {
      return this.step === 3 && this.upgradStatus === 1;
    },
    /** 升级已失败终态：避免异步流程将失败页回写为 step=1/2 */
    isFirmwareUpgradeFailedFinal () {
      return this.step === 3 && this.upgradStatus === 0 && this.upgrading === 2;
    },
    /** 升级终态（成功/失败） */
    isFirmwareUpgradeFinal () {
      return (
        this.isFirmwareUpgradeSuccessFinal() ||
        this.isFirmwareUpgradeFailedFinal()
      );
    },
    onUnexpectedDisconnect () {
      console.log(
        "onUnexpectedDisconnect",
        this.upgrading,
        this.isChanged,
        this.step,
        this.isDownLoad
      );

      if (this.upgrading === 2) {
        if (this.online) {
          this.upgradText = this.upgradText || "设备已断开连接，请检查后重试";
        } else {
          this.upgradText = "网络异常，请检查后重试";
          this.uploadErrTip = "";
        }

        this.upgradStatus = 0;
        this.step = 3;
        // 上报全渠道 OTA 升级失败（设备连接意外断开）
        reportOTATracking('failed', {
          packageNm: this.glassDeviceType ? this.glassDeviceType.packageName : '',
          glassesVersion: this.currentVersion || '',
          glasses_model: this.deviceTypeName || (this.glassDeviceType ? this.glassDeviceType.deviceType : this.deviceType || ''),
          SN: (this.selectedDevice && this.selectedDevice.serialNumber) || (this.currentDevice && this.currentDevice.serialNumber) || '',
          destversion: this.upgradeVersion || '',
          error_message: 'Device disconnected unexpectedly'
        });
      } else {
        this.upgradText = "";
        this.uploadErrTip = "";

        if (this.upgrading === 0) {
          this.step = 1;
        }
      }

      this.clearManifestSuccessFallbackTimer();
      if (this.upgrading === 3 && this.isDownLoad) {
        // 默认你成功 - 旧眼镜存在最后存在 NetworkError 的情况
        this.manifestSuccessFallbackTimerId = setTimeout(() => {
          this.manifestSuccessFallbackTimerId = null;
          this.dfuDownLoadSuccess();
        }, 45000);
      }

      this.resetData();
    },
    async onConnect () {
      console.log("connected", this.upgrading, this.isChanged, this.isDownLoad);

      this.clearManifestSuccessFallbackTimer();

      switch (this.upgrading) {
        case 3:
          // this.upgradStatus = 1;
          // this.step = 3;

          this.percentage = 100;
          break;
        case 2:
          this.upgradStatus = 0;
          this.step = 3;
          this.percentage = 0;
          break;
        case 1:
          // 设备在升级过程中断开连接又重新连  升级/修复失败
          // if (this.isDownLoad) {
          //   this.upgradStatus = 0;
          //   this.step = 3;
          //   this.percentage = 0;
          // }
          break;
        case 0:
          if (!this.isFirmwareUpgradeSuccessFinal()) {
            this.step = 1;
            this.upgradStatus = 0;
            this.percentage = 0;
          }
          break;

        default:
          break;
      }

      this.isDownLoad = false;

      this.updateData({
        isFirstConnect: false,
      });

      let devicesALl = await navigator.usb.getDevices();

      let filters = [
        { vendorId: 0x1bbb },
        { vendorId: 0x0483 },
        { vendorId: 0x3941 },
      ];

      let devices = devicesALl.filter((device) => {
        return filters.some((filter) => filter.vendorId === device.vendorId);
      });

      console.log("devices", devicesALl, devices);

      if (devices.length > 1) {
        this.$message({
          message: "请确保升级过程中仅有一台 Rayneo 眼镜与电脑连接哦",
          type: "warning",
        });

        while (devices.length > 1) {
          await new Promise((resolve) => setTimeout(resolve, 1000));
          let devicesall = await navigator.usb.getDevices();

          devices = devicesall.filter((device) => {
            return filters.some(
              (filter) => filter.vendorId === device.vendorId
            );
          });
        }
      }

      if (devices.length === 1) {
        // this.selectedDevice = devices[0];
        // let currentDevice = devices[0];

        console.log("this---", devices);

        this.connectTimer && clearInterval(this.connectTimer);

        if (this.upgrading === 3) {
          console.log("devices.vendorId", devices[0].vendorId);
          let cvid = devices[0].vendorId;
          console.log("cvid", cvid);
          if ([0x1bbb, 0x0483, 0x3941].includes(cvid)) {
            this.dfuDownLoadSuccess();
            this.upgrading = 0;
          }
        }

        this.updateData({
          selectedDevice: devices[0],
        });

        const interfacesData = this.getCurrentDeiceType(devices[0]);
        const usbKind = this.getUsbConnectionKind(devices[0]);
        console.log("interfacesData / usbKind", interfacesData, usbKind);

        if (usbKind === "dfu" && interfacesData.length > 0) {
          this.settings = interfacesData[0];

        
          if (this.upgrading === 0 && !this.isChanged) {
              // 当前是 dfu 模式
              console.log("onConnect - 当前是 dfu 模式, 由hid转dfu");
              this.isDFU = true;
              this.initStatus = 1;
              this.getDFUDeviceData(devices[0]).then(() => {
                if (!this.isFirmwareUpgradeSuccessFinal()) {
                  this.step = 2;
                }
              }).catch(e => {
                console.error("[OTA] DFU getDFUDeviceData error in onConnect:", e);
              });
          }else{
              this.isDFU = false;
          }

          console.log("this.upgrading", this.upgrading, this.isChanged);

          // 初次 HID 转 DFU 授权时 upgrading 已为 1，避免 onConnect 再拉一次包
          // 失败(2) / 收尾(3) 时勿自动下载，否则断线重连会误进 handleToDeviceDownLoad
          const skipFirstAuthRedundant =
            this.upgrading === 1 && this.isChanged;
          const skipWhileFailedOrFinishing =
            this.upgrading === 2 || this.upgrading === 3 || this.upgrading === 0;

          if (skipFirstAuthRedundant) {
            console.log("初次授权不需要直接下载了");
          } else if (!skipWhileFailedOrFinishing) {
            await this.handleToDeviceDownLoad();
          } else {
            console.log(
              "[OTA] onConnect DFU: skip auto download, upgrading=",
              this.upgrading
            );
          }
        } else {
          this.isDFU = false;
        }
      } else {
        console.log("this---n", devices);
        this.updateData({
          selectedDevice: null,
        });
      }
    },

    /**
     * 按 USB 枚举 VID+PID 区分 DFU 引导态与「应用态 / 走 WebHID 读版本」形态。
     * DFU：0483:df11（STM）、3941:af51（双子）、1bbb:af51（白羊金牛 DFU）
     * HID 应用枚举：1bbb:af50、3941:af50（与 getDeviceVersion 中 WebHID filters 一致）
     */
    getUsbConnectionKind (device) {
      if (!device) return "hid";
      const v = device.vendorId;
      const p = device.productId;
      if (
        (v === 0x0483 && p === 0xdf11) ||
        (v === 0x3941 && p === 0xaf51) ||
        (v === 0x1bbb && p === 0xaf51)
      ) {
        return "dfu";
      }
      if ((v === 0x1bbb && p === 0xaf50) || (v === 0x3941 && p === 0xaf50)) {
        return "hid";
      }
      return "hid";
    },

    /** 与 getDeviceVersion 中 WebHID filters 一致，用于全局插拔过滤 */
    isRayneoHidDevice (device) {
      if (!device) return false;
      const { vendorId, productId } = device;
      return (
        (vendorId === 0x1bbb && productId === 0xaf50) ||
        (vendorId === 0x3941 && productId === 0xaf50)
      );
    },


    getCurrentDeiceType (device) {
      let interfacesArr = [];
      try {
        for (let conf of device?.configurations || []) {
          for (let intf of conf.interfaces || []) {
            for (let alt of intf.alternates || []) {
              if (
                alt.interfaceClass == 0xfe &&
                alt.interfaceSubclass == 0x01 &&
                (alt.interfaceProtocol == 0x01 || alt.interfaceProtocol == 0x02)
              ) {
                let settings = {
                  configuration: conf,
                  interface: intf,
                  alternate: alt,
                  name: alt.interfaceName,
                };
                interfacesArr.push(settings);
              }
            }
          }
        }
      } catch (error) {
        console.log("getCurrentDeiceType error:", error);
        this.upgrading = 2;
        this.upgradStatus = 0;
        this.step = 3;
        this.upgradText = "固件升级失败，请拔插眼镜后重新升级";
        this.uploadErrTip = String(error?.message || error || "");
        this.handleFailedTrack();
        this.isChanged = false;
        return [];
      }

      return interfacesArr;
    },
    /**
     * 当 WebUSB 未解析出 interface 字符串名时，
     * 通过标准 GET_DESCRIPTOR 读配置与 string descriptor，补全 settings.name（不依赖 dfu.js）。
     */
    async fixInterfaceNames (device_, interfaces) {
      if (!device_ || !interfaces?.length) {
        return;
      }
      if (!interfaces.some((intf) => intf.name == null)) {
        return;
      }

      try {
        if (!device_.opened) {
          await device_.open();
        }
        await device_.selectConfiguration(1);
        const mapping = await readInterfaceNamesMapping(device_);
        for (const intf of interfaces) {
          if (intf.name == null) {
            const configValue = intf.configuration.configurationValue;
            const intfNumber = intf["interface"].interfaceNumber;
            const alt = intf.alternate.alternateSetting;
            const resolved =
              mapping[configValue]?.[intfNumber]?.[alt] ?? null;
            if (resolved != null) {
              intf.name = resolved;
            }
          }
        }
      } catch (e) {
        console.log("[OTA] fixInterfaceNames failed:", e);
      } finally {
        try {
          await device_.close();
        } catch (error) {
          console.log(error);
        }
      }
    },

    handleResize () {
      let baseSIze = document.documentElement.style.fontSize;
      this.strokeWidth = (parseInt(baseSIze) * 28) / 16;
    },
    async updateNetworkStatus () {
      console.log("navigator", navigator.onLine);
      try {
        const response = await fetch("https://rayneo.cn", {
          method: "HEAD",
          mode: "no-cors",
        });
        if (response.ok || response.type === "opaque") {
          console.log("网络连接正常");
          this.online = true;
        } else {
          console.log("网络连接断开");
          this.online = false;
        }
      } catch (error) {
        console.log("网络连接断开");
        this.online = false;
      }
    },
    handleToShow () {
      this.show = true;
      // 埋点-点击按钮-提示信息
      reportData({ ButtonName: "button_windows_npopen" });
    },
    handleToClose () {
      this.show = false;
    },
    handleToCloseDetail () {
      this.showDetail = false;
    },
    async getDeviceInfo (tag, hexstr) {
      try {
        let deviceNameRes = await getDeviceName(tag);
        let deviceImgRes = await getDeviceImg(tag);

        this.deviceName =
          ((deviceNameRes.data || {}).data || {}).content || hexstr || "";
        this.deviceImg = ((deviceImgRes.data || {}).data || {}).content || "";
        console.log("[设备型号] getDeviceInfo 设备名称:", this.deviceName, "设备型号码:", hexstr, "tag:", tag);

        if (!this.deviceImg) {
          this.loading = false;
        }
      } catch (error) {
        console.log("getDeviceInfo error", error);
        this.loading = false;

        this.$message({
          message: `获取设备信息失败(${error.message || error})，请刷新页面重试`,
          type: "error",
        });
      }
    },

    async handleToReq () {
      const filters = [
        { vendorId: 0x1bbb, productId: 0xaf50 },
        { vendorId: 0x3941, productId: 0xaf50 },
        { vendorId: 0x0483, productId: 0xdf11 },
        { vendorId: 0x3941, productId: 0xaf51 },
        { vendorId: 0x1bbb, productId: 0xaf51 },
      ];
      navigator.usb
        .requestDevice({ filters })
        .then(async (selectedDevice) => {
          console.log(
            "selectedDevice",
            selectedDevice,
            this.upgrading,
            this.isChanged
          );

          //   this.selectedDevice = selectedDevice;
          this.updateData({
            selectedDevice: selectedDevice,
          });

          // 埋点-触发事件-连接设备成功
          const deviceId = this.getSafeDeviceId(null, selectedDevice);
          reportData({
            VisitName: {
              visit_select_device_success: true,
            },
            Device_Id: deviceId,
          });


          const usbKind = this.getUsbConnectionKind(selectedDevice);
          console.log("usbKind", usbKind);
          const interfacesData = this.getCurrentDeiceType(selectedDevice);
          console.log("interfacesData-------", interfacesData);
          await this.fixInterfaceNames(selectedDevice, interfacesData);
          console.log("fixInterfaceNames - interfacesData", interfacesData);

          this.isDFU = false;

          if (usbKind === "dfu") {
            if (this.upgrading === 0 && !this.isChanged) {
              // 当前是 dfu 模式
              console.log("getDFUDeviceData - 当前是 dfu 模式");
              this.isDFU = true;
            }

            if (interfacesData.length > 0) {
              this.settings = interfacesData[0];

              await this.updateNetworkStatus();
              if (this.online) {
                await this.getDFUDeviceData(selectedDevice);
                if (!this.isFirmwareUpgradeFinal()) {
                  this.step = 2;
                }

                if (this.upgrading === 1 && this.isChanged) {
                  console.log(" DFU : getCurrentDeiceType");
                  // 初次授权直接升级
                  await this.handleToDeviceDownLoad();
                } else {
                  this.initStatus = 1;
                }
              }
              if (!this.isFirmwareUpgradeFinal()) {
                this.step = 2;
              }
            }
          } else {
            if (this.upgrading === 0 && !this.isChanged) {
              this.isDFU = false;
              this.initStatus = 0;
            }
            await this.getDeviceVersion();
          }

          this.requestLoading = false;
        })
        .catch((error) => {
          console.log("error", error);
          this.requestLoading = false;

          if (this.upgrading === 1 && this.isChanged) {
            this.step = 3;
            this.upgradStatus = 0;
            this.upgrading = 2;
            this.isDownLoad = false;
            this.percentage = 0;
            this.upgradText = "固件升级失败，请选择设备连接后重试";
            this.uploadErrTip = "";
            this.handleFailedTrack();
          } else {
            this.initStatus = 1;
          }
        });
    },

    async handleToConnect () {
      console.log(
        "this.online",
        this.online,
        !this.isFirstConnect,
        this.isDFU,
        this.selectedDevice
      );


      this.initData();

      this.requestLoading = true;

      if (this.online) {
        // 埋点-点击按钮-开始连接
        reportData({
          ButtonName: "button_start_connect",
        });
        if (this.isFirstConnect || !this.selectedDevice) {
          this.handleToReq();
        } else {
          const usbKind = this.getUsbConnectionKind(this.selectedDevice);
          // const interfacesData = this.getCurrentDeiceType(this.selectedDevice);
          console.log("usbKind / interfacesData", usbKind);

          this.isDFU = false;

          if (usbKind === "dfu") {
            this.isDFU = true;
            await this.updateNetworkStatus();
            if (this.online) {
              await this.getDFUDeviceData(this.selectedDevice);
              if (!this.isFirmwareUpgradeSuccessFinal()) {
                this.step = 2;
              }
              this.initStatus = 1;
            }
          } else {
            this.isDFU = false;
            await this.getDeviceVersion();
            // 埋点-触发事件-连接设备成功
            const deviceId = this.getSafeDeviceId(null, this.selectedDevice);
            reportData({
              VisitName: {
                visit_select_device_success: true,
              },
              Device_Id: deviceId,
            });

            this.initStatus = 0;
          }
          this.requestLoading = false;
        }
      } else {
        this.requestLoading = false;

        await this.updateNetworkStatus();

        if (this.online) {
          await this.handleToConnect();
        }
      }
    },
    async handleToReUpgrade () {
      this.currentVersion = "";
      this.firmwareUrl = "";
      this.initData();

      // await this.handleToConnect();
      // await this.handleToUpgrade();
    },
    async handleToUpgrade () {
      await this.updateNetworkStatus();

      // initStatus ? "修复固件" : "升级固件"
      const deviceId = this.getSafeDeviceId(null, this.selectedDevice);
      if (this.initStatus) {
        // 埋点-点击按钮-固件修复
        reportData({
          ButtonName: "button_firmware_repair",
          Device_Id: deviceId,
        });
      } else {
        // 埋点-点击按钮-固件升级
        reportData({
          ButtonName: "button_firmware_update",
          Device_Id: deviceId,
        });
      }
      // 上报全渠道 OTA 升级开始埋点
      reportOTATracking('start', {
        packageNm: this.glassDeviceType ? this.glassDeviceType.packageName : '',
        glassesVersion: this.currentVersion || '',
        glasses_model: this.deviceTypeName || (this.glassDeviceType ? this.glassDeviceType.deviceType : this.deviceType || ''),
        SN: (this.selectedDevice && this.selectedDevice.serialNumber) || (this.currentDevice && this.currentDevice.serialNumber) || '',
        destversion: this.upgradeVersion || ''
      });
      this.$nextTick(async () => {
        if (this.online) {
          if (this.isDFU) {
            console.log("直接升级");
            await this.handleToDeviceDownLoad();
          } else {
            console.log("先转化成 dfu 再升级");

            const outputData = new Uint8Array(64);
            outputData[0] = 0x66;
            outputData[1] = 0x66;

            console.log("outputData", outputData, this.currentDevice);

            try {
              let sendD = await this.currentDevice.sendReport(0, outputData);

              console.log("sendD", sendD);
              this.upgrading = 1;
              this.isChanged = true;
              setTimeout(async () => {
                await this.handleToReq();
              }, 500);
            } catch (error) {
              console.log("sendD--error", error);
            }
          }
        }
      });
    },

    /**
     * dfuse 设备下载固件
     * @param xfer_size 传输大小
     * @param data 数据
     * @param manifestationTolerant 是否容忍异常
     */
    async dfuseDownLoad (xfer_size, data, manifestationTolerant) {
      console.log(xfer_size, data, manifestationTolerant);

      // this.upgrading = 2;
      let initPercentage = 0;

      let firmwarePID;
      let firmwareVID;
      let firmwareBootVersion;
      //   let firmwareMaxBlockSize = 1024;

      let elementStartAddress;
      let elementLength;

      let elementStartAddress2;
      let elementLength2;

      let NumElements;

      function async_sleep (duration_ms) {
        return new Promise(function (resolve) {
          console.log("Sleeping for " + duration_ms + "ms");
          setTimeout(resolve, duration_ms);
        });
      }

      function async_sleep_increasePercentage (duration_ms, updateFunction) {
        return new Promise(function (resolve) {
          let _percentage = 0; // 初始 percentage 为 0
          const targetPercentage = 10; // 目标 percentage 为 10
          const increment = 0.1; // 每次增加的步长

          const interval =
            duration_ms / ((targetPercentage - _percentage) / increment); // 计算每次增加的时间间隔

          const timer = setInterval(() => {
            _percentage += increment; // 逐渐增加 percentage
            updateFunction(_percentage); // 更新 percentage

            if (_percentage >= targetPercentage) {
              clearInterval(timer); // 达到目标 percentage 后清除定时器
              resolve(); // 完成 Promise
            }
          }, interval);
        });
      }

      const uint8Array = new Uint8Array(data);

      let ELEMENT1_OFFSET = 293; // constant offset in file array where image data starts
      let TARGET_NUM_ELEMENTS = 281;

      // Get VID, PID and version number
      firmwareVID = (uint8Array[data.byteLength - 11] & 0xff) << 8;
      firmwareVID |= uint8Array[data.byteLength - 12] & 0xff;
      firmwarePID = (uint8Array[data.byteLength - 13] & 0xff) << 8;
      firmwarePID |= uint8Array[data.byteLength - 14] & 0xff;
      firmwareBootVersion = (uint8Array[data.byteLength - 15] & 0xff) << 8;
      firmwareBootVersion |= uint8Array[data.byteLength - 16] & 0xff;

      NumElements = uint8Array[TARGET_NUM_ELEMENTS] & 0xff;
      NumElements |= (uint8Array[TARGET_NUM_ELEMENTS + 1] & 0xff) << 8;
      NumElements |= (uint8Array[TARGET_NUM_ELEMENTS + 2] & 0xff) << 16;
      NumElements |= (uint8Array[TARGET_NUM_ELEMENTS + 3] & 0xff) << 24;

      elementStartAddress = uint8Array[285] & 0xff;
      elementStartAddress |= (uint8Array[286] & 0xff) << 8;
      elementStartAddress |= (uint8Array[287] & 0xff) << 16;
      elementStartAddress |= (uint8Array[288] & 0xff) << 24;

      //   if (this.selectedDevice.startAddress != elementStartAddress) {
      //     throw (
      //       "Error start address in file: 0x" + elementStartAddress.toString(16)
      //     );
      //   }

      elementLength = uint8Array[289] & 0xff;
      elementLength |= (uint8Array[290] & 0xff) << 8;
      elementLength |= (uint8Array[291] & 0xff) << 16;
      elementLength |= (uint8Array[292] & 0xff) << 24;

      console.log(`elementLength: ${elementLength}`);

      if (NumElements > 1) {
        let offset = 8 + elementLength;
        // Get Element Flash start address and size
        elementStartAddress2 = uint8Array[285 + offset] & 0xff;
        elementStartAddress2 |= (uint8Array[286 + offset] & 0xff) << 8;
        elementStartAddress2 |= (uint8Array[287 + offset] & 0xff) << 16;
        elementStartAddress2 |= (uint8Array[288 + offset] & 0xff) << 24;
        // this.logInfo(`elementStartAddress2: 0x${elementStartAddress2.toString(16)}`);

        elementLength2 = uint8Array[289 + offset] & 0xff;
        elementLength2 |= (uint8Array[290 + offset] & 0xff) << 8;
        elementLength2 |= (uint8Array[291 + offset] & 0xff) << 16;
        elementLength2 |= (uint8Array[292 + offset] & 0xff) << 24;
        console.log(`elementLength2: 0x${elementLength2.toString(16)}`);

        if (elementStartAddress2 > 0x801ffff) {
          NumElements = 1;
          elementLength2 = 0;
        }
      } else {
        elementLength2 = 0;
      }

      console.log(
        "elementLength2",
        elementLength,
        elementLength2,
        firmwareVID,
        firmwarePID,
        firmwareBootVersion,
        this.glass_version
      );

      console.log("Erasing DFU device memory");

      let bytes_sent = 0;
      let expected_size = data.byteLength;

      console.log("expected_size", expected_size);

      let startAddress = elementStartAddress;
      // let pollingTime = 50;

      if (this.glass_version == 0x00) {
        console.log("设备版本号为 0x00，不支持升级");
      } else {
        let dfu_status;
        if (isNaN(startAddress)) {
          startAddress = this.memoryInfo.segments[0].start;
          console.log(
            "Using inferred start address 0x" + startAddress.toString(16)
          );
        }

        try {
          // 发送指令 getStatus 来检查设备的当前状态
          do {
            await this.clearStatus();
            dfu_status = await this.getStatus();
          } while (dfu_status.state != 2);

          console.log("Erasing sector 0x41414141");
          // 发送指令
          await this.erase(0x41414141, 5);
          console.log("Erasing sector done 0x41414141");

          // await async_sleep(1000);
          // 这里按照产品交互要求做一个假进度
          await async_sleep_increasePercentage(1000, (percentage) => {
            console.log("当前 percentage 为: " + percentage.toFixed(1));
            initPercentage = percentage;

            this.percentage = initPercentage;
          });

          dfu_status = await this.getStatus(); // initiate erase command, returns 'download busy' even if invalid address or ROP
          console.log("getStatus " + dfu_status.state.toString());
          //let pollingTime = dfu_status.pollTimeout;  // note requested waiting time
          do {
            await async_sleep(1000);
            await this.clearStatus();
            console.log("clearStatus done");
            await async_sleep(100);
            dfu_status = await this.getStatus();
            console.log("getStatus " + dfu_status.state.toString());
          } while (dfu_status.state != 2);
        } catch (error) {
          //
          if (error) {
            this.isChanged = false;
            this.upgrading = 2;
            this.upgradText = "固件升级失败，请拔插眼镜后重新升级";
            this.uploadErrTip = error;
            this.handleFailedTrack();
          }
        }
      }
      console.log("Copying data from browser to DFU device");

      await async_sleep(100);

      /**
       * 按 Element1 + Element2 实际 payload 总字节映射进度条 [initPercentage, initPercentage+88]。
       * 单段时仅 phase1；双段时 phase1Done 最大为 elementLength，phase2 为第二段已写字节。
       */
      const applyDfuSeUiProgress = (phase1Done, phase2Done = 0) => {
        const len1 = Math.max(0, elementLength | 0);
        const len2 = Math.max(0, elementLength2 | 0);
        const total = len1 + len2;
        if (total <= 0) {
          this.percentage = Math.min(100, initPercentage + 88);
          return;
        }
        const p1 = Math.min(len1, Math.max(0, phase1Done));
        const p2 = Math.min(len2, Math.max(0, phase2Done));
        const done = Math.min(total, p1 + p2);
        const overall = Math.min(100, (done / total) * 100);
        this.percentage = initPercentage + (overall / 100) * 88;
      };

      let percentage = 0;

      let address = startAddress;
      let blocknum = 0;
      expected_size = elementLength;
      console.log("Start Element1", expected_size, elementLength);

      while (bytes_sent < expected_size) {
        const bytes_left = expected_size - bytes_sent;
        const chunk_size = Math.min(bytes_left, xfer_size);

        let bytes_written = 0;
        let dfu_status;

        console.log("blocknum", blocknum, address);

        try {
          await async_sleep(50);

          do {
            await this.clearStatus();
            dfu_status = await this.getStatus();
          } while (dfu_status.state != 2);

          if (blocknum == 0) {
            await this.dfuseCommand(0x21, address, 4);
            console.log(`Set address to 0x${address.toString(16)}`);

            dfu_status = await this.getStatus();

            dfu_status = await this.getStatus();
            if (dfu_status.state == 10) {
              console.log("download status error0 ");
            }
          }

          do {
            await this.clearStatus();
            dfu_status = await this.getStatus();
          } while (dfu_status.state != 2);

          //this.logInfo("write block: " + blocknum);
          bytes_written = await this.download(
            data.slice(
              bytes_sent + ELEMENT1_OFFSET,
              bytes_sent + ELEMENT1_OFFSET + chunk_size
            ),
            2 + blocknum
          );
          dfu_status = await this.getStatus();
          if (dfu_status.state != 4) {
            console.log("download status error1 ");
          }

          await async_sleep(100);

          dfu_status = await this.getStatus(); // to verify action

          if (dfu_status.state == 10) {
            console.log("download status error2:", dfu_status);

            this.upgrading = 2;
            this.upgradText = "固件升级失败，请拔插眼镜后重新升级";
            this.uploadErrTip = "download status error2: " + dfu_status;
            this.handleFailedTrack();
            this.isChanged = false;
            throw "download status error2: " + dfu_status;
          }
          //this.logDebug("Sent " + bytes_written + " bytes");

          while (dfu_status.state != 2) {
            await this.clearStatus();
            dfu_status = await this.getStatus();
          }

          address += chunk_size;
          blocknum++;
        } catch (error) {
          console.log("Error during DfuSe download-1:", error);

          if (error) {
            this.isChanged = false;
            this.upgrading = 2;
            this.upgradText = "固件升级失败，请拔插眼镜后重新升级";
            this.uploadErrTip = error;
            this.handleFailedTrack();
            throw "Error during DfuSe download-1: " + error;
          }
        }

        //this.logDebug("Wrote " + bytes_written + " bytes");
        bytes_sent += bytes_written;

        percentage = Math.max(
          0,
          Math.min(100, (bytes_sent / expected_size) * 100)
        );

        console.log("bytes_sent", bytes_sent, expected_size, percentage);
        applyDfuSeUiProgress(bytes_sent, 0);
      }

      address = elementStartAddress2;
      blocknum = 0;
      expected_size = elementLength2;
      bytes_sent = 0;
      console.log("Start Element2", { elementLength, elementLength2 });
      if (expected_size <= 0) {
        applyDfuSeUiProgress(elementLength, 0);
      }
      while (bytes_sent < expected_size) {
        console.log("bytes_sent < expected_size", bytes_sent, expected_size);
        const bytes_left = expected_size - bytes_sent;
        const chunk_size = Math.min(bytes_left, xfer_size);

        let bytes_written = 0;
        let dfu_status;

        try {
          await async_sleep(50);

          do {
            await this.clearStatus();
            dfu_status = await this.getStatus();
          } while (dfu_status.state != 2);

          if (blocknum == 0) {
            await this.dfuseCommand(0x21, address, 4);
            //this.logInfo(`Set address to 0x${address.toString(16)}`);
            dfu_status = await this.getStatus();
            dfu_status = await this.getStatus();
            if (dfu_status.state == 10) {
              console.log("download status error0 ");
            }
          }

          do {
            await this.clearStatus();
            dfu_status = await this.getStatus();
          } while (dfu_status.state != 2);

          //this.logInfo("write block: " + blocknum);
          bytes_written = await this.download(
            data.slice(
              bytes_sent + ELEMENT1_OFFSET + elementLength + 8,
              bytes_sent + ELEMENT1_OFFSET + elementLength + 8 + chunk_size
            ),
            2 + blocknum
          );
          dfu_status = await this.getStatus();
          if (dfu_status.state != 4) {
            console.log("download status error1 ");
          }
          await async_sleep(100);
          dfu_status = await this.getStatus(); // to verify action

          //   console.log("Start Element2 - duf_status", dfu_status);
          if (dfu_status.state == 10) {
            console.log("download status error2:", dfu_status);

            this.upgrading = 2;
            this.upgradText = "固件升级失败，请拔插眼镜后重新升级";
            this.uploadErrTip = "download status error2: " + dfu_status;
            this.handleFailedTrack();

            this.isChanged = false;
            throw "download status error2: " + dfu_status;
          }
          //this.logInfo("Sent " + bytes_written + " bytes");

          while (dfu_status.state != 2) {
            await this.clearStatus();
            dfu_status = await this.getStatus();
          }
          address += chunk_size;
          blocknum++;
        } catch (error) {
          console.log("Error during DfuSe download-2:", error);
          if (error) {
            this.upgrading = 2;
            this.upgradText = "固件升级失败，请拔插眼镜后重新升级";
            this.uploadErrTip = error;
            this.handleFailedTrack();
            this.isChanged = false;
            throw "Error during DfuSe download-2: " + error;
          }

          //
        }

        console.log("-----------", bytes_written);

        //this.logDebug("Wrote " + bytes_written + " bytes");
        bytes_sent += bytes_written;

        applyDfuSeUiProgress(elementLength, bytes_sent);
        console.log(
          "dfuse el2",
          bytes_sent,
          expected_size,
          "doneBytes",
          elementLength + bytes_sent
        );
      }

      applyDfuSeUiProgress(elementLength, Math.max(0, elementLength2));

      console.log("Manifesting new firmware");
      await async_sleep(5);
      let dfu_status;
      try {
        dfu_status = await this.getStatus();
        while (dfu_status.state != 2) {
          await this.clearStatus();
          dfu_status = await this.getStatus();
        }

        await this.dfuseCommand(0x21, startAddress, 4);
        dfu_status = await this.getStatus();
        while (dfu_status.state != 2) {
          await this.clearStatus();
          dfu_status = await this.getStatus();
        }

        await this.download(new ArrayBuffer(), 0);

        // is_upgrading = 2;

        dfu_status = await this.getStatus(); //maybe already disconnected

        await this.clearStatus();
        dfu_status = await this.getStatus();

        console.log("upgrading finished", dfu_status);

        //upgrading finished
      } catch (error) {
        console.log("Error during DfuSe download-3:", error);
        // this.upgrading = 2;
        // this.step = 3;
        // this.upgradStatus = 0;
        // if (error) {
        //   this.upgrading = 2
        //   this.upgradText = error;
        //   throw "Error during DfuSe manifestation: " + error;
        // }
      }

      this.upgrading = 3;
    },


    /**
     * 标准 DFU 下载 - 双子
     * @param {number} xfer_size 单块最大长度
     * @param {ArrayBuffer|ArrayBufferView} data 固件二进制
     * @param {boolean} manifestationTolerant 是否 manifestation tolerant（影响收尾轮询）
     * @param {{ taskIndex: number, taskCount: number } | null} [progressSlice] 多 ZIP 子任务时按索引分摊总进度；不传则占满 0–100%
     */
    async dfuDownLoad (
      xfer_size,
      data,
      manifestationTolerant,
      progressSlice = null
    ) {
      const DFU_STATUS_OK = 0;
      const DFU_DNLOAD_IDLE = 5;
      const DFU_IDLE = 2;
      const DFU_ERROR = 10;
      const DFU_MANIFEST_WAIT_RESET = 8;
      this.upgrading = 1;

      console.log("dfuDownLoad - start-------", this.upgrading);

      const taskIndex =
        progressSlice &&
        typeof progressSlice.taskIndex === "number" &&
        progressSlice.taskIndex >= 0
          ? progressSlice.taskIndex
          : 0;
      const taskCount =
        progressSlice &&
        typeof progressSlice.taskCount === "number" &&
        progressSlice.taskCount >= 1
          ? progressSlice.taskCount
          : 1;
      const progressBase = (taskIndex / taskCount) * 100;
      const progressSpan = 100 / taskCount;
      const toGlobalPercent = (local0to100) => {
        const clamped = Math.max(0, Math.min(100, local0to100));
        return Math.min(
          100,
          Math.floor(progressBase + (clamped / 100) * progressSpan)
        );
      };

      if (!data || !data.byteLength) {
        throw new Error("DFU 固件数据为空");
      }

      let bytes_sent = 0;
      const expected_size = data.byteLength;
      let transaction = 0;

      console.log("[OTA] DFU download 开始", expected_size, "bytes");
      this.percentage = Math.floor(progressBase);

      while (bytes_sent < expected_size) {
        const bytes_left = expected_size - bytes_sent;
        const chunk_size = Math.min(bytes_left, xfer_size);

        let bytes_written;
        let dfu_status;
        try {
          const chunk = data.slice(bytes_sent, bytes_sent + chunk_size);
          bytes_written = await this.download(chunk, transaction++);
          console.log("Wrote " + bytes_written + " bytes");
          dfu_status = await this.poll_until_idle(DFU_DNLOAD_IDLE);
          console.log("dfu_status-------", dfu_status);
        } catch (error) {
          this.upgrading = 2;
          this.upgradText = "固件升级失败，请拔插眼镜后重新升级";
          this.uploadErrTip = error;
          this.handleFailedTrack();
          this.isChanged = false;
          throw new Error(`Error during DFU download: ${error}`);
        }

        if (dfu_status.status !== DFU_STATUS_OK) {
          this.upgrading = 2;
          this.upgradText = "固件升级失败，请拔插眼镜后重新升级";
          this.uploadErrTip = `DFU DOWNLOAD failed state=${dfu_status.state}, status=${dfu_status.status}`;
          this.handleFailedTrack();
          this.isChanged = false;
          throw new Error(
            `DFU DOWNLOAD failed state=${dfu_status.state}, status=${dfu_status.status}`
          );
        }
        console.log("Wrote " + bytes_written + " bytes");
        bytes_sent += bytes_written;
        this.percentage = toGlobalPercent(
          Math.min(99, Math.floor((bytes_sent / expected_size) * 100))
        );
      }

      console.log("[OTA] DFU sending final empty block", this.upgrading);
      try {
        await this.download(new ArrayBuffer([]), transaction++);
      } catch (error) {
        this.upgrading = 2;
        this.upgradText = "固件升级失败，请拔插眼镜后重新升级";
        this.uploadErrTip = error;
        this.handleFailedTrack();
        this.isChanged = false;
        throw new Error(`Error during final DFU download: ${error}`);
      }

      console.log(
        "[OTA] DFU wrote",
        bytes_sent,
        "bytes; manifesting, manifestationTolerant=",
        manifestationTolerant
      );

      if (manifestationTolerant) {
        try {
          const dfu_status = await this.poll_until(
            (state) =>
              state === DFU_IDLE || state === DFU_MANIFEST_WAIT_RESET
          );
          if (dfu_status.status !== DFU_STATUS_OK) {
            throw new Error(
              `DFU MANIFEST failed state=${dfu_status.state}, status=${dfu_status.status}`
            );
          }
        } catch (error) {
          const msg = String(error);
          if (
            msg.endsWith(
              "ControlTransferIn failed: NotFoundError: Device unavailable."
            ) ||
            msg.endsWith(
              "ControlTransferIn failed: NotFoundError: The device was disconnected."
            )
          ) {
            console.warn("[OTA] Unable to poll final manifestation status");
          } else {
            throw new Error(`Error during DFU manifest: ${error}`);
          }
        }
      } else {
        const totalTime = 20000;
        const startTime = Date.now();
        const progressTimer = setInterval(() => {
          const elapsed = Date.now() - startTime;
          const localM = Math.min(
            100,
            Math.floor((elapsed / totalTime) * 100)
          );
          const globalM = toGlobalPercent(localM);
          this.percentage = Math.max(this.percentage, globalM);
        }, 500);

        try {
          let dfu_status = await this.getStatus();
          console.log("dfu_status-------", dfu_status, this.upgrading,this.percentage);
          while (
            dfu_status.state !== DFU_IDLE &&
            dfu_status.state !== DFU_ERROR
          ) {
            await new Promise((resolve) =>
              setTimeout(resolve, dfu_status.pollTimeout)
            );
            dfu_status = await this.getStatus();
            console.log("while dfu_status-------", dfu_status, this.upgrading);
          }
          clearInterval(progressTimer);
          this.percentage = toGlobalPercent(100);
          console.log(
            "[OTA] Final DFU status:",
            dfu_status.state,
            dfu_status.status,
            this.upgrading,
            this.percentage
          );
 
        } catch (error) {
          clearInterval(progressTimer);
          this.percentage = toGlobalPercent(100);
        }
      }

      console.log("[OTA] DFU download Done", this.upgrading,this.showProgress,this.percentage);
    },


    async erase (startAddr) {
      await this.dfuseCommand(0x41, startAddr, 4);
    },

    async dfuseCommand (command, param, len) {
      if (typeof param === "undefined" && typeof len === "undefined") {
        param = 0x00;
        len = 1;
      }

      const commandNames = {
        0x00: "GET_COMMANDS",
        0x21: "SET_ADDRESS",
        0x41: "ERASE_SECTOR",
      };

      let payload = new ArrayBuffer(len + 1);
      let view = new DataView(payload);
      view.setUint8(0, command);
      if (len == 1) {
        view.setUint8(1, param);
      } else if (len == 4) {
        view.setUint32(1, param, true);
      } else {
        throw "Don't know how to handle data of len " + len;
      }

      try {
        await this.download(payload, 0);
      } catch (error) {
        throw (
          "Error during special DfuSe command " +
          commandNames[command] +
          ":" +
          error
        );
      }

      //let status = await this.poll_until(state => (state != dfu.dfuDNBUSY));
      //if (status.status != dfu.STATUS_OK) {
      //    throw "Special DfuSe command " + commandName + " failed";
      //}
    },

    /**
     * 解析下载得到的固件：非 ZIP 返回单包；ZIP 返回解压后的 .dfu 条目列表（与 DFU 接口配对在 buildDfuZipUpgradeTasks）。
     */
    async resolveFirmwareDownloadPayload (firmwareUrl, response, rawBuffer) {
      const url = (firmwareUrl || "").toLowerCase();
      const pathPart = url.split("?")[0] || url;
      const contentType =
        (response && response.headers.get("content-type")) || "";
      const looksLikeZip =
        pathPart.endsWith(".zip") ||
        pathPart.includes(".zip/") ||
        contentType.includes("zip");

      if (!looksLikeZip) {
        return { kind: "single", buffer: rawBuffer };
      }

      const entries = await unzipDfuEntries(rawBuffer);
      if (!entries || entries.length === 0) {
        throw new Error("ZIP 包内未找到 .dfu 固件文件");
      }
      if (entries.length > 1) {
        console.warn(
          "[OTA] ZIP 内含多个 .dfu：",
          entries.map((e) => e.name)
        );
      }
      return { kind: "zip", entries };
    },

    /**
     * 固定顺序：先 osd_images，再 firmware；仅当设备 DFU 接口名与 ZIP 内条目名均包含同一关键字时才加入任务。
     */
   async buildDfuZipUpgradeTasks (selectedDevice, zipEntries) {
      const priorities = ['osd_images', 'firmware'];
      const interfaces = this.getCurrentDeiceType(selectedDevice);
      await this.fixInterfaceNames(selectedDevice, interfaces);
      console.log("buildDfuZipUpgradeTasks -----interfaces", interfaces);
      console.log("buildDfuZipUpgradeTasks -----zipEntries", zipEntries);
      const norm = (s) => (s || "").toLowerCase();
      const upgradeTasks = [];
      for (const priority of priorities) {
        const k = norm(priority);
        // 查找匹配的接口
        let matchedIntf = null;
        for (let intf of interfaces) {
          let intfName = norm(intf.name);
          if (intfName.includes(k)) {
            matchedIntf = intf;
            break;
          }
        }
        if (!matchedIntf) {
          continue;
        }
        // 查找匹配的 ZIP 条目
        let matchedFile = null;
        for (let file of zipEntries) {
          let fileName = norm(file.name);
          if (fileName.includes(k)) {
            matchedFile = file;
            break;
          }
        }
        if (matchedFile) {
          upgradeTasks.push({
            interface: matchedIntf,
            file: matchedFile,
            buffer: matchedFile.data,
            keyword: priority
          });
        }
      }
      if (upgradeTasks.length === 0) {
        throw new Error("未找到任何匹配的升级任务");
      }
      console.log("upgradeTasks-------", upgradeTasks);
      return upgradeTasks;
    },
    getSafeDeviceId (fallback = null, device = null) {
      let selectedDevice = null;
      try {
        selectedDevice = device || this.selectedDevice;
      } catch (error) {
        console.warn("[OTA] 读取 selectedDevice 失败", error);
      }

      const productId = selectedDevice && selectedDevice.productId;
      const vendorId = selectedDevice && selectedDevice.vendorId;
      console.log("getSafeDeviceId", vendorId, productId);
      if (vendorId != null && productId != null) {
        return `${vendorId}_${productId}`;
      }
      return fallback;
    },

    async dfuDownLoadSuccess () {
      this.clearManifestSuccessFallbackTimer();
      this.upgrading = 3;
      this.step = 3;
      this.upgradStatus = 1;
      // 上报全渠道 OTA 升级成功埋点
      reportOTATracking('success', {
        packageNm: this.glassDeviceType ? this.glassDeviceType.packageName : '',
        glassesVersion: this.currentVersion || '',
        glasses_model: this.deviceTypeName || (this.glassDeviceType ? this.glassDeviceType.deviceType : this.deviceType || ''),
        SN: (this.selectedDevice && this.selectedDevice.serialNumber) || (this.currentDevice && this.currentDevice.serialNumber) || '',
        destversion: this.upgradeVersion || ''
      });
      // initStatus ? "修复固件" : "升级固件"
      const deviceId = this.getSafeDeviceId(null, this.selectedDevice);
      console.log("this.initStatus-------", this.initStatus,this.step,this.upgradStatus,this.currentVersion,this.upgradeVersion,this.selectedDevice);
      if (this.initStatus) {
        // 埋点-触发事件-固件修复成功
        reportData({
          VisitName: {
            visit_firmware_repair_success: true,
            ...(this.currentVersion
              ? {
                visit_firmware_currentOTA_version: this.currentVersion,
              }
              : {}),
            visit_firmware_successOTA_version: this.upgradeVersion,
          },
          Device_Id: deviceId,
          Duration: `${(Date.now() - Window.visitTime) / 1000}s`,
        });
      } else {
        // 埋点-触发事件-固件升级成功
        reportData({
          VisitName: {
            visit_firmware_update_success: true,
            visit_firmware_currentOTA_version: this.currentVersion,
            visit_firmware_successOTA_version: this.upgradeVersion,
          },
          Device_Id: deviceId,
          Duration: `${(Date.now() - Window.visitTime) / 1000}s`,
        });
      }
      this.percentage = 0;
      this.upgrading = 0;
      this.isDownLoad = false;
    },

    async handleToDeviceDownLoad () {
      console.log("下载固件", this.selectedDevice, this.settings);

      if (!this.selectedDevice) {
        console.log("设备已断开连接，无法升级");
        this.upgrading = 2;
        this.upgradStatus = 0; // 升级失败
        this.step = 3;
        this.upgradText = "设备已断开连接，请检查后重试";
        this.uploadErrTip = ""; 
        return;
      }

      if (!this.firmwareUrl) {
        console.log("固件升级地址为空，无法升级");
        this.upgrading = 2;
        this.upgradStatus = 0;
        this.step = 3;
        this.upgradText = "固件升级地址为空，无法升级";
        this.uploadErrTip = "";
        this.handleFailedTrack();
        return;
      }

      this.upgrading = 1;
      this.showProgress = true; 

      const downloadTimeoutMs = 45000;
      const downloadStartAt = Date.now();
      const abortController =
        typeof AbortController !== "undefined" ? new AbortController() : null;
      let downloadAbortTimer = null;

      try {
        if (abortController) {
          downloadAbortTimer = setTimeout(() => {
            console.warn(
              `[OTA] 固件下载超时，已中断请求（${downloadTimeoutMs}ms）`
            );
            abortController.abort();
          }, downloadTimeoutMs);
        }
        console.log("process.env.NODE_ENV", process.env.NODE_ENV,abortController);
        let response;
        if (process.env.NODE_ENV === "production") {
          response = await fetch(this.firmwareUrl, {
            method: "GET",
            signal: abortController ? abortController.signal : undefined,
            // mode: "cors",
            // headers: {
            //   "Content-Type": "application/json",
            // },
          });
        } else {
          // 本地cdn 出现了缓存导致会出现下载失败的情况
          response = await fetch(
            "/res/9675ca65/thirdapk_8869b668963c0869213f54f87416344f.dfu",
            {
              signal: abortController ? abortController.signal : undefined,
            }
          );
        }

        console.log("response", response);
        if (!(response.ok || response.type === "opaque")){
          console.log("网络连接断开");
          this.online = false;
          throw new Error("Failed to download firmware file.");
        }

        console.log("response.ok", response.ok, response.type,response.arrayBuffer);

        const firmwareArrayBuffer = await response.arrayBuffer();
        console.log("downloadAbortTimer", downloadAbortTimer,firmwareArrayBuffer);
        if (downloadAbortTimer != null) {
          clearTimeout(downloadAbortTimer);
          downloadAbortTimer = null;
        }
        console.log(
          "[OTA] 固件下载耗时(ms)",
          Date.now() - downloadStartAt
        );
        console.log("firmwareArrayBuffer", firmwareArrayBuffer);
        if (firmwareArrayBuffer) {
          console.log("网络连接正常");
          this.online = true;
        } else {
          console.log("网络连接断开或固件下载失败");
          this.online = false;
          throw new Error("Failed to download firmware file.");
        }
        const resolved = await this.resolveFirmwareDownloadPayload(
          this.firmwareUrl,
          response,
          firmwareArrayBuffer
        );

        const xfer_size = 1024;
        this.clearManifestSuccessFallbackTimer();       
        this.isDownLoad = true;

        if (resolved.kind === "single") {
          // 非 zip 单包
          console.log("f - single", resolved.buffer, this.settings);
          await this.openDevice(this.selectedDevice, this.settings);

          let desc = await getDFUDescriptorProperties(this.selectedDevice, this.settings);
          console.log("desc-------", desc);
          if (desc && desc.DFUVersion == 0x011a && this.settings.alternate.interfaceProtocol == 0x02) {
            // 如果是 dfuse 设备，走 dfuse 下载
            console.log("dfuse 设备，走 dfuse 下载");
            await this.dfuseDownLoad(xfer_size, resolved.buffer, false);
          }else{
            console.log("dfu 设备，走 dfu 下载");
            try {
              await this.dfuDownLoad(xfer_size, resolved.buffer, false);
              console.log("所有固件下载完成");
              await this.dfuDownLoadSuccess();
            } catch (error) {
              console.log("dfu 设备，走 dfu 下载失败", error);
              this.upgrading = 2;
              const errMsg = error && error.message ? String(error.message) : "";
              this.upgradText = this.online
                ? errMsg || "固件升级请求失败，请检查网络重试"
                : errMsg;
              this.uploadErrTip = "";
              this.handleFailedTrack();
              this.step = 3;
              this.upgradStatus = 0;
            }
            
          }
        } else {
          const upgradeTasks = await this.buildDfuZipUpgradeTasks(
            this.selectedDevice,
            resolved.entries
          );

          if (!upgradeTasks.length) {
            throw new Error(
              "ZIP 内 .dfu 与设备 DFU 接口无法按 osd_images / firmware 配对，请检查固件包与设备"
            );
          }
          let zipAllTasksOk = true;
          for (let i = 0; i < upgradeTasks.length; i++) {
            const task = upgradeTasks[i];
            console.log(
              "[OTA] DFU ZIP 子任务",
              i + 1,
              "/",
              upgradeTasks.length,
              task.keyword
            );
            console.log(`目标接口: ${task.interface.name}`);
            console.log(`DFU文件: ${task.file.name}`);

            // 如果不是当前接口，需要关闭并重新连接
            let needReconnect = false;
            const cur = this.settings;
            if (
              cur &&
              cur.alternate &&
              cur["interface"] &&
              task.interface &&
              task.interface.alternate &&
              task.interface["interface"]
            ) {
              if (
                cur.alternate.alternateSetting !==
                  task.interface.alternate.alternateSetting ||
                cur["interface"].interfaceNumber !==
                  task.interface["interface"].interfaceNumber
              ) {
                needReconnect = true;
              }
              // 如果当前为 alt1 且走 ZIP，也需要重新连接
              if (
                cur.alternate.alternateSetting === 1 &&
                resolved.kind === "zip"
              ) {
                needReconnect = true;
              }
            }

            if (needReconnect) {
              console.log("[OTA] ZIP 关闭当前 USB 会话并准备重连目标接口");
              await resetUsbSessionForDfuSwitch(this.selectedDevice);
            }

            this.settings = task.interface;
            await this.openDevice(this.selectedDevice, this.settings);

         
            // 清除 DFU 状态
            try {
              const dfu_status = await this.getStatus();
              if (dfu_status.state === 10) {
                await this.clearStatus();
              }
            } catch (error) {
              console.warn("[OTA] ZIP 子任务清除 DFU 状态失败", error);
            }

            console.log("开始下载固件");
            try {
              let desc = await getDFUDescriptorProperties(this.selectedDevice, this.settings);
              console.log("desc-------", desc);
              if (desc && desc.DFUVersion == 0x011a && device.settings.alternate.interfaceProtocol == 0x02) {
                // 如果是 dfuse 设备，走 dfuse 下载 - 实际上不存在dfuse
                console.log("dfuse 设备，走 dfuse 下载 - 实际上不存在dfuse");
                
              }else{
                console.log("dfu 设备，走 dfu 下载");
                await this.dfuDownLoad(xfer_size, task.buffer, false, {
                  taskIndex: i,
                  taskCount: upgradeTasks.length,
                });
                console.log(`下载${i+1}固件完成 ${task.file.name}`);
              }

              
            } catch (error) {
              console.log(`下载${i+1}固件失败 ${task.file.name}`, error);
              zipAllTasksOk = false;
              this.upgrading = 2;
              const errMsg = error && error.message ? String(error.message) : "";
              this.upgradText = this.online
                ? errMsg || "固件升级请求失败，请检查网络重试"
                : errMsg;
              this.uploadErrTip = "";
              this.handleFailedTrack();
              this.step = 3;
              this.upgradStatus = 0;
              break;
            }
            
          }

          if (zipAllTasksOk) {
            console.log("所有固件下载完成");
            await this.dfuDownLoadSuccess();
          }

        }
      } catch (error) {
        console.log("featch-error", error);

        this.upgrading = 2;
        const errMsg = error && error.message ? String(error.message) : "";
        if (error && error.name === "AbortError") {
          this.online = false;
        }
        this.upgradText = this.online
          ? errMsg || "固件升级请求失败，请检查网络重试"
          : errMsg;
        this.uploadErrTip = "";
        this.handleFailedTrack();
        this.step = 3;
        this.upgradStatus = 0;
      } finally {
        if (downloadAbortTimer != null) {
          clearTimeout(downloadAbortTimer);
          downloadAbortTimer = null;
        }
      }
    },

    download (data, blockNum) {
      return requestOut(
        this.selectedDevice,
        this.settings["interface"].interfaceNumber,
        0x01,
        data,
        blockNum
      );
    },

    poll_until_idle (idle_state) {
      return this.poll_until((state) => state == idle_state);
    },

    getStatus () {
      return requestIn(
        this.selectedDevice,
        this.settings["interface"].interfaceNumber,
        0x03,
        6
      ).then(
        (data) =>
          Promise.resolve({
            status: data.getUint8(0),
            pollTimeout: data.getUint32(1, true) & 0xffffff,
            state: data.getUint8(4),
          }),
        (error) => Promise.reject("DFU GETSTATUS failed: " + error)
      );
    },

    clearStatus () {
      return requestOut(
        this.selectedDevice,
        this.settings["interface"].interfaceNumber,
        0x04
      );
    },

    async poll_until (state_predicate) {
      let dfu_status = await this.getStatus();

      function async_sleep (duration_ms) {
        return new Promise(function (resolve) {
          console.log("Sleeping for " + duration_ms + "ms");
          // device.logDebug("Sleeping for " + duration_ms + "ms");
          setTimeout(resolve, duration_ms);
        });
      }

      while (!state_predicate(dfu_status.state) && dfu_status.state != 10) {
        await async_sleep(dfu_status.pollTimeout);
        dfu_status = await this.getStatus();
      }

      return dfu_status;
    },

    getUpgradeVersion (clientType, packageName) {
      console.log("clientType", clientType, packageName);
      getXrOTA(clientType, packageName)
        .then((res) => {
          console.log("----getXrOTA----", res);

          if (res.data.code === 100000) {
            let data = res.data.data;

            if (data.length <= 0) {
              this.instrodution = "";
              this.upgradeVersion = "";
              this.firmwareUrl = "";
              this.loading = false;
              return;
            }

            let ossUrl = (data[0] || {}).ossUrl || "";
            let versionCode = (data[0] || {}).versionCode;
            let instrodution = (data[0] || {}).instrodution;

            console.log("ossUrl", ossUrl, versionCode, instrodution);
            this.instrodution = instrodution
              ? instrodution.replace(/\n/g, "<br>")
              : "";
            this.upgradeVersion = versionCode.toString();
            this.firmwareUrl = ossUrl;
            // 测试 - dfuse - zip
            // this.firmwareUrl = "https://file-tdp-ffalcon.test.leiniao.com/res/5c61abaa/thirdapk_81de3bd1b0a37f7f8e2464614eab2cb8.zip";
            // 测试双子 - 单dfu - 放public下的本地文件
            // this.firmwareUrl = `${process.env.BASE_URL}firmware/gemini_firmware_20260509_153747.dfu`;
          }
        })
        .catch(() => {
          this.instrodution = "";
          this.upgradeVersion = "";
          this.firmwareUrl = "";
        }).finally(() => {
          this.loading = false;
        });
    },

    /**
     *
     * @param device USB设备对象
     * @param interfaceNumber USB接口编号
     * @param xfer_size 传输大小
     */
    async getDFUDeviceFeature (device, interfaceNumber, xfer_size) {
      // getStatus 函数被频繁调用的原因是为了确保设备的状态在每个操作步骤中都是正确的和预期的。
      //  在执行任何关键操作之前，代码会调用 getStatus 来检查设备的当前状态。如果设备不在预期的状态（例如状态码不为2），则会通过 clearStatus 清除当前状态并重新检查，直到设备准备好接收新的命令。
      let dfu_status = await this.getStatus();
      while (dfu_status.state != 2) {
        await this.clearStatus();
        dfu_status = await this.getStatus();
      }

      //   发送指令
      await this.dfuseCommand(0x21, 0x08000000, 4);
      //  在发送命令后，代码会再次调用 getStatus 来验证命令是否成功执行
      dfu_status = await this.getStatus();
      dfu_status = await this.getStatus();
      if (dfu_status.state == 10) {
        console.log("download status error0 ");
      }

      // 等待设备完成操作，操作可能需要设备花费一定时间来完成，所以轮训
      do {
        await this.clearStatus();
        dfu_status = await this.getStatus();
      } while (dfu_status.state != 2);

      //   接受请求处理
      let result;
      result = await requestIn(device, interfaceNumber, 0x02, xfer_size, 2);

      //   再次处理设备状态变化
      dfu_status = await this.getStatus();
      while (dfu_status.state != 2) {
        await this.clearStatus();
        dfu_status = await this.getStatus();
      }

      return result;
    },

    async openDevice (selectedDevice, settings) {
      if (selectedDevice) {
        if (!selectedDevice.opened) {
          await selectedDevice.open();
        }

        const confValue = settings.configuration.configurationValue;

        if (
          selectedDevice.configuration === null ||
          selectedDevice.configuration.configurationValue != confValue
        ) {
          await selectedDevice.selectConfiguration(confValue);
        }

        const intfNumber = settings["interface"].interfaceNumber;
        console.log("intfNumber", intfNumber);
        const intf = selectedDevice.configuration.interfaces.find(
          (i) => i.interfaceNumber === intfNumber
        );
        if (!intf) {
          throw new Error(
            `未找到 interfaceNumber=${intfNumber} 的 USB 接口，无法 claim`
          );
        }

        if (!intf.claimed) {
          await selectedDevice.claimInterface(intfNumber);
        }
        const altSetting = settings.alternate.alternateSetting;
        console.log("altSetting", altSetting);

        console.log("in", intf);

        if (
          intf.alternate === null ||
          intf.alternate.alternateSetting != altSetting ||
          intf.alternates.length > 1
        ) {
          console.log("selectAlternateInterface", intfNumber, altSetting);
          try {
            await selectedDevice.selectAlternateInterface(
              intfNumber,
              altSetting
            );
            console.log(
              "selectAlternateInterface success",
              intfNumber,
              altSetting
            );
          } catch (error) {
            if (
              intf.alternate.alternateSetting == altSetting &&
              error.endsWith("Unable to set device interface.")
            ) {
              console.log(
                `Redundant SET_INTERFACE request to select altSetting ${altSetting} failed`
              );
            } else {
              throw error;
            }
          }
        }
      }
    },

    async getDeviceID (glass_version) {
      // 白羊=aries，白羊1.5=aries1p5，白羊1.8=aries1.8，金牛=taurus，金牛1.5=taurus1p5，金牛2.0=taurus2p0
      console.log("glass_version", glass_version);
      let hexstr = "";
      switch (glass_version) {
        case 0x21:
          hexstr = "aries";
          break;
        case 0x22:
        case 0x23:
          hexstr = "aries1p5";
          break;
        case 0x24:
          hexstr = "aries1p8";
          break;
        case 0x29:
          hexstr = "arieslx";
          break;
        case 0x30:
          hexstr = "taurus";
          break;
        case 0x31:
          hexstr = "taurus1p5";
          break;
        case 0x34:
        case 0x38:
          hexstr = "taurus2p0pro";
          break;
        case 0x35:
          hexstr = "taurus2p0";
          break;
        case 0x36:
          hexstr = "taurus3p0";
          break;
        case 0x37:
          hexstr = "taurus3p0pro";
          break;
        case 0x39:
          hexstr = "taurus4p0";
          break;
        case 0x3a:
          hexstr = "taurus4p0pro";
          break;
        case 0x40:
          hexstr = "Gemini1p0";
          break;
        case 0x41:
          hexstr = "Gemini2p0";
          break;
        default:
          hexstr = glass_version.toString(16).toUpperCase();
          break;
      }

      return hexstr;
    },

    /** DFU 控制传输读出的构建日期字符串规范化（调试用） */
    formatDfuProbeBuildDate (dateStr) {
      if (dateStr && /^\d{8}$/.test(dateStr)) {
        return dateStr;
      }
      if (dateStr && dateStr.includes(" ")) {
        const months = {
          Jan: "01",
          Feb: "02",
          Mar: "03",
          Apr: "04",
          May: "05",
          Jun: "06",
          Jul: "07",
          Aug: "08",
          Sep: "09",
          Oct: "10",
          Nov: "11",
          Dec: "12",
        };
        const parts = dateStr.split(" ");
        if (parts.length === 3) {
          const month = months[parts[0]] || "01";
          let day = parts[1].replace(",", "");
          if (day.length === 1) day = `0${day}`;
          const year = parts[2];
          return `${year}${month}${day}`;
        }
      }
      if (dateStr && /^\d+$/.test(dateStr)) {
        return dateStr;
      }
      return dateStr || "未知";
    },

    /** 雷鸟 DFU（AF51）且 glass_version 仍为 0：无法走 STM32 feature，需类传输探测 */
    isRayneoDfuGlassProbe (device) {
      console.log("isRayneoDfuGlassProbe - device", device,this.glass_version,device?.productId === 0xaf51);
      const vidOk =
        device.vendorId === 0x1bbb || device.vendorId === 0x3941;
      console.log("vidOk", vidOk);
      return vidOk && device.productId === 0xaf51;
    },

    /** 第一个 DFU 模式 alternate（class 0xFE / sub 0x01 / protocol 0x02） */
    findFirstDfuModeInterfaceAlternate (rawDevice) {
      const interfaces = rawDevice?.configuration?.interfaces;
      if (!interfaces?.length) {
        return null;
      }
      for (const iface of interfaces) {
        for (const alt of iface.alternates) {
          if (
            alt.interfaceClass === 0xfe &&
            alt.interfaceSubclass === 0x01 &&
            alt.interfaceProtocol === 0x02
          ) {
            return {
              interfaceNumber: iface.interfaceNumber,
              dfuAlternateSetting: alt.alternateSetting,
            };
          }
        }
      }
      return null;
    },

    readDfuProbeBuildDateFromVersionReply (view, byteLength) {
      let raw = "";
      for (let i = 0; i < 12 && 4 + i < byteLength; i++) {
        const c = view.getUint8(4 + i);
        if (c !== 0) {
          raw += String.fromCharCode(c);
        }
      }
      return raw;
    },

    async cleanupRayneoDfuVersionProbeUsb (rawDevice, interfaceNumber) {
      if (!rawDevice?.opened) {
        return;
      }
      if (interfaceNumber != null) {
        try {
          await rawDevice.controlTransferOut(
            {
              requestType: "class",
              recipient: "interface",
              request: 0x06,
              value: 0,
              index: interfaceNumber,
            },
            new ArrayBuffer(0)
          );
        } catch (e) {
          console.debug("[OTA] controlTransferOut cleanup (version probe)", e);
        }
        try {
          await rawDevice.releaseInterface(interfaceNumber);
        } catch (e) {
          console.debug("[OTA] releaseInterface (version probe)", e);
        }
      }
      try {
        await rawDevice.close();
      } catch (e) {
        console.debug("[OTA] close (version probe)", e);
      }
    },

    /** 根据字典项拉设备图文与 OTA 列表（Rayneo 探测与 STM32 路径共用） */
    async loadOtaCatalogForGlassDevice (glassDeviceType, displayKey) {
      if (!glassDeviceType) {
        return;
      }
      this.glassDeviceType = glassDeviceType;
      try {
        await this.getDeviceInfo(glassDeviceType.deviceType, displayKey);
        await this.getUpgradeVersion(
          glassDeviceType.clientType,
          glassDeviceType.packageName
        );
        console.log("[设备型号] loadOtaCatalog 设备型号码:", displayKey, "设备名称:", this.deviceName, "glassDeviceType:", glassDeviceType);
      } catch (error) {
        console.log("error", error);
      }
    },

    /**
     * glass_version=0 时通过 DFU 类请求取设备类型字节与构建日期，再匹配 OTA。
     * 使用 finally 保证异常时仍释放 USB。
     */
    async runRayneoDfuUnknownGlassVersionProbe (device) {
      console.log(
        "[OTA] Rayneo DFU AF51, glass_version=0, control-transfer version probe"
      );
      await new Promise((r) => setTimeout(r, 200));

      const rawDevice = device;
      let probeInterfaceNumber = null;

      try {
        await rawDevice.open();
        if (rawDevice.configuration === null) {
          await rawDevice.selectConfiguration(1);
        }

        const dfuIf = this.findFirstDfuModeInterfaceAlternate(rawDevice);
        if (!dfuIf) {
          console.warn("[OTA] No DFU mode alternate (protocol 0x02) found");
          return;
        }

        probeInterfaceNumber = dfuIf.interfaceNumber;
        const { dfuAlternateSetting } = dfuIf;

        try {
          await rawDevice.claimInterface(probeInterfaceNumber);
        } catch (e) {
          console.debug("[OTA] claimInterface (version probe)", e);
        }
        try {
          await rawDevice.selectAlternateInterface(
            probeInterfaceNumber,
            dfuAlternateSetting
          );
        } catch (e) {
          console.debug(
            "[OTA] selectAlternateInterface (version probe)",
            probeInterfaceNumber,
            dfuAlternateSetting,
            e
          );
        }

        await this.recoverRayneoDfuControlForVersionProbe(
          rawDevice,
          probeInterfaceNumber
        );

        const result = await rawDevice.controlTransferIn(
          {
            requestType: "class",
            recipient: "interface",
            request: 0x02,
            value: 0xff00,
            index: probeInterfaceNumber,
          },
          16
        );

        console.log("[OTA] Rayneo DFU version probe result", result);

        if (result.status !== "ok") {
          console.warn(
            "[OTA] Rayneo DFU version probe failed, status=",
            result.status
          );
          return;
        }

        if (!result.data || result.data.byteLength < 4) {
          console.log("[DEBUG] Version data too short");
          return;
        }

        const view = new DataView(result.data.buffer);
        const deviceTypeByte = view.getUint8(0);
        const rawBuildDate = this.readDfuProbeBuildDateFromVersionReply(
          view,
          result.data.byteLength
        );
        const deviceTypeName = await this.getDeviceID(deviceTypeByte);
        const buildDate = this.formatDfuProbeBuildDate(rawBuildDate);
        const glassParamMap = getDeviceParam(deviceTypeName);
        const glassDeviceType = glassParamMap[deviceTypeName];
        this.deviceTypeName = deviceTypeName;
        console.log("[OTA] glass_device_type", glassDeviceType);
        await this.loadOtaCatalogForGlassDevice(
          glassDeviceType,
          deviceTypeName
        );
        console.log(
          "[DEBUG] Device Type:",
          deviceTypeName,
          "Build Date:",
          buildDate
        );
      } catch (e) {
        console.log("[DEBUG] Version query failed:", e.message || e);
      } finally {
        await this.cleanupRayneoDfuVersionProbeUsb(
          rawDevice,
          probeInterfaceNumber
        );
      }
    },

    /** STM32（VID 0483）DFU：通过 GET_STATUS 类 feature 取 glass_version / cu，再走 OTA */
    async loadStm32DfuDeviceMetadata (device, intfNumber) {
      const feature = await this.getDFUDeviceFeature(device, intfNumber, 2);
      console.log("getDFUDeviceData----", feature);

      this.glass_version = feature.getUint8(1);
      console.log("this.glass_version", this.glass_version);

      if (this.glass_version > 0x30) {
        this.cu_version = feature.getUint8(0);
      }

      if (this.cu_version < 1 || this.cu_version === 0x31) {
        this.cu_version = 1;
      }

      let cuType = null;
      if (![null, ""].includes(this.cu_version)) {
        cuType = parseInt(this.cu_version, 16);
      }

      const hexstr = await this.getDeviceID(this.glass_version);
      const glassParamMap = getDeviceParam(cuType);

      console.log("glass_deice_types", glassParamMap);

      const glassDeviceType = glassParamMap[hexstr];
      this.deviceTypeName = hexstr;
      console.log("glass_device_type", glassDeviceType, hexstr);

      await this.loadOtaCatalogForGlassDevice(glassDeviceType, hexstr);

      const textContent = `Glass Version = ${hexstr},  Cu Version = 0x${this.cu_version
        .toString(16)
        .toUpperCase()}`;
      console.log("textContent", textContent);
    },

    /**
     * 获取 DFU 设备侧信息并驱动 OTA 列表。
     * - Rayneo AF51 且 glass_version 仍为 0：类传输探测（无法走 STM32 feature）。
     * - 其它：openDevice 后 STM32(0483) 用 GET_STATUS feature 取版本与字典。
     */
    async getDFUDeviceData (device) {
      console.log("getDFUDeviceData", device, device?.productId === 0xaf51);
      if(!device){
        throw new Error("device is null");
        return; 
      }

      if (this.isRayneoDfuGlassProbe(device)) {
        console.log("isRayneoDfuGlassProbe", this.glass_version);
        if(this.glass_version === 0x00){
          console.log("glass_version is 0x00");
          await this.runRayneoDfuUnknownGlassVersionProbe(device);
          return;
        }else{
          console.log("glass_version is not 0x00");
          // 直接拿glass_version
          const deviceTypeName = await this.getDeviceID(this.glass_version);
          const glassParamMap = getDeviceParam(deviceTypeName);
          const glassDeviceType = glassParamMap[deviceTypeName];
          this.deviceTypeName = deviceTypeName;
          console.log("[OTA] glass_device_type", glassDeviceType);
          await this.loadOtaCatalogForGlassDevice(
            glassDeviceType,
            deviceTypeName
          );
          console.log(
            "[DEBUG] Device Type:",
            deviceTypeName
          );
          return;
        }
        
      }

      

      await this.openDevice(device, this.settings);

      if (device.vendorId === 0x0483) {
        const intfNumber = this.settings["interface"].interfaceNumber;
        await this.loadStm32DfuDeviceMetadata(device, intfNumber);
      }
    },

    async getDeviceVersion () {
      //  经过调试发现此方案行不通，HID 模式下接口是受保护的 claimInterface 报错
      // await this.openDevice(this.selectedDevice, this.settings);

      try {
        const devices = await navigator.hid.requestDevice({
          filters: [
            {
              vendorId: 0x1bbb, // 根据VID进行过滤
              productId: 0xaf50, // 根据PID进行过滤
            },
            {
              vendorId: 0x3941, // 根据VID进行过滤
              productId: 0xaf50, // 根据PID进行过滤
            },
          ],
        });

        console.log("getDeviceVersion - devices", devices);

        if (devices.length === 0) {
          if (!this.isFirmwareUpgradeFinal()) {
            this.step = 1;
          }
          return;
        }
        //  放在这里的原因是 请求弹窗不要做延迟，立马弹出
        await this.updateNetworkStatus();
        console.log("this.online", this.online);

        if (this.online) {
          if (!this.isFirmwareUpgradeFinal()) {
            console.log("this.isFirmwareUpgradeFinal is false");
            this.step = 2;
          }

          this.loading = true;

          let currentDevice = devices[0];

          this.currentDevice = currentDevice;

          if (!currentDevice.opened) {
            await currentDevice.open();
          }

          const outputData = new Uint8Array(64);
          outputData[0] = 0x66;
          outputData[1] = 0x00;

          await currentDevice.sendReport(0, outputData);

          // 电脑接收到来自设备的消息回调
          currentDevice.oninputreport = async (event) => {
            console.log("event", event); // event中包含device、reportId、data等内容
            let array = new Uint8Array(event.data.buffer); // event.data.buffer就是接收到的inputreport包数据了

            if (array[1] === 0xc8 && array[8] === 0x0) {
              this.glass_version = array[21];

              console.log("this.glass_version", this.glass_version);

              if (this.glass_version > 0x30) {
                this.cu_version = array[47];
              }
              if (this.cu_version < 1) {
                this.cu_version = 1;
              }

              let glass_firmware_version = "";

              let l = array[36];
              l &= 0xff;
              l |= array[37] << 8;

              l &= 0xffff;
              let year = l;
              let month = array[38];
              let day = array[39];

              // 使用模板字符串构建日期字符串
              glass_firmware_version = `20${year.toString()}`;
              if (month < 10) {
                glass_firmware_version += `0${month.toString()}`;
              } else {
                glass_firmware_version += `${month.toString()}`;
              }
              if (day < 10) {
                glass_firmware_version += `0${day.toString()}`;
              } else {
                glass_firmware_version += `${day.toString()}`;
              }

              let cuType = null;
              if ([null, ""].includes(this.cu_version) === false) {
                cuType = parseInt(this.cu_version, 16);
              }

              console.log("cuType", cuType);

              let hexstr = await this.getDeviceID(this.glass_version);
              let glass_deice_types = getDeviceParam(cuType);
              console.log("hexstr", hexstr, glass_deice_types);

              let glass_device_type = glass_deice_types[hexstr];

              console.log("glass_device_type", glass_device_type);

              if (glass_device_type) {
                this.glassDeviceType = glass_device_type;
                this.deviceTypeName = hexstr;

                await this.getDeviceInfo(glass_device_type.deviceType, hexstr);

                await this.getUpgradeVersion(
                  glass_device_type.clientType,
                  glass_device_type.packageName
                );
              }

              this.deviceType = hexstr;

              let textContent = `Glass Version = ${glass_firmware_version}`;
              console.log("textContent", textContent);

              this.currentVersion = glass_firmware_version;
            }
          };
        }else{
          console.log("getDeviceVersion hid error: device is not rayneo dfu glass");
        }
      } catch (error) {
        console.log("getDeviceVersion hid error:", error);
        this.loading = false;
      }
    },
    handleFailedTrack (errMsg = '') {
      // 上报全渠道 OTA 升级失败埋点
      reportOTATracking('failed', {
        packageNm: this.glassDeviceType ? this.glassDeviceType.packageName : '',
        glassesVersion: this.currentVersion || '',
        glasses_model: this.deviceTypeName || (this.glassDeviceType ? this.glassDeviceType.deviceType : this.deviceType || ''),
        SN: (this.selectedDevice && this.selectedDevice.serialNumber) || (this.currentDevice && this.currentDevice.serialNumber) || '',
        destversion: this.upgradeVersion || '',
        error_message: errMsg || 'Upgrade failed'
      });
      // initStatus ? "修复固件" : "升级固件"
      const deviceId = this.getSafeDeviceId(null, this.selectedDevice);
      if (this.initStatus) {
        // 埋点-触发事件-固件修复失败
        reportData({
          VisitName: {
            visit_firmware_repair_failed: true,
            ...(this.currentVersion
              ? {
                visit_firmware_currentOTA_version: this.currentVersion,
              }
              : {}),
          },
          ...(deviceId
            ? {
              Device_Id: deviceId,
            }
            : {}),
        });
      } else {
        // 埋点-触发事件-固件升级失败
        reportData({
          VisitName: {
            visit_firmware_update_failed: true,
            ...(this.currentVersion
              ? {
                visit_firmware_currentOTA_version: this.currentVersion,
              }
              : {}),
          },
          ...(deviceId
            ? {
              Device_Id: deviceId,
            }
            : {}),
        });
      }
    },
  },
};
</script>
